module.exports = __webpack_public_path__ + "img/play.b0c1baa6.png";